import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import { Colors, Styles, tableStyles} from '../../../../src/styles/theme';
import { Button} from 'reactstrap';
import { FiCheckSquare, FiXSquare  } from "react-icons/fi";
class PlanList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      
      // Todos os filtros começam marcados (mostra tudo)
      filterAtivo: true,
      filterInativo: true,
      filterPublicado: true,
      filterNaoPublicado: true,

      showTable: false
    };

    this.styles = {
      error: { textAlign: 'center', fontSize: 18, color:'#ea0000', background:'#fff', padding:10, borderRadius: 3, fontWeight: 500 },
      zero: { textAlign: 'center', fontSize: 18, background:'#fff', padding:10, borderRadius: 3, fontWeight: 500 },
      filterContainer: {
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '20px', background: '#fff',
        padding: '12px 15px', borderRadius: '8px', marginBottom: '15px', marginLeft: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      },
      filterGroup: { display: 'flex', alignItems: 'center', gap: '12px' },
      filterLabel: { fontSize: '14px', fontWeight: 'bold', color: Colors.textDark, marginRight: '5px' },
      checkboxLabel: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', cursor: 'pointer', userSelect: 'none' },
      divider: { width: '1px', height: '20px', backgroundColor: '#e0e0e0', margin: '0 5px' }
    };
    this.error = '';
  }

  componentWillMount() {
    this.getData(urlBase.loopBack + 'Plans');
  }

componentDidMount() {
    // Cria a regra customizada de filtro na API do DataTables
    $.fn.dataTable.ext.search.push(
      (settings, data) => {
        if (settings.nTable.id !== 'table_id') return true;

        // Pega os valores textuais que estão nas colunas da tabela
        // Coluna 11 é Publicado (índice 11) e Coluna 12 é Status (índice 12)
        const txtPublicado = data[11] ? data[11].toUpperCase() : '';
        const txtStatus = data[12] ? data[12].toUpperCase() : '';

        // Identifica o estado com base nas marcas textuais ocultas que injetamos nas células
        const isPublicado = txtPublicado.includes('PUBLICADO_SIM');
        const isNaoPublicado = txtPublicado.includes('RASCUNHO_NAO');
        
        // Nova identificação precisa para Status Ativo/Inativo
        const isAtivo = txtStatus.includes('STATUS_ATIVO');
        const isInativo = txtStatus.includes('STATUS_INATIVO');

        // Valida as regras com o estado atual dos checkboxes
        let passaStatus = false;
        if (this.state.filterAtivo && isAtivo) passaStatus = true;
        if (this.state.filterInativo && isInativo) passaStatus = true;

        let passaPublish = false;
        if (this.state.filterPublicado && isPublicado) passaPublish = true;
        if (this.state.filterNaoPublicado && isNaoPublicado) passaPublish = true;

        return passaStatus && passaPublish;
      }
    );
  }
  // Quando os checkboxes mudarem, apenas disparar o redesenho do DataTables (.draw())
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.filterAtivo !== this.state.filterAtivo ||
      prevState.filterInativo !== this.state.filterInativo ||
      prevState.filterPublicado !== this.state.filterPublicado ||
      prevState.filterNaoPublicado !== this.state.filterNaoPublicado
    ) {
      if ($.fn.DataTable.isDataTable('#table_id')) {
        $('#table_id').DataTable().draw(); // Filtra instantaneamente sem recriar a tabela
      }
    }
  }

  initDataTable() {
    if (!$.fn.DataTable.isDataTable('#table_id')) {
      setTimeout(() => {
        $('#table_id').DataTable({
          "language": {
            "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
          },
          "order": [[0, "asc"]],
          lengthMenu: [
            [10, 25, 50, 100, -1],
            ['10', '25', '50', 100, 'Todas']
          ]
        });
      }, 50);
    }
  }

  handleFilterChange (event) {
    const { name, checked } = event.target;
    this.setState({ [name]: checked });
  }

  getData(url) {
    axios.get(url)
    .then((response) => {
      let state = this.state;
      if (response.data.length == 0) state.data = 'zero';
      else state.data = response.data;

      this.setState(state, () => {
        if (Array.isArray(this.state.data)) {
          this.initDataTable();
        }
      });
    })
    .catch(function (error) {
      let state = this.state;
      state.error = error.message;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  edit(id) {
    window.location.href= urlBase.client +'panel/planregistration?edit='+id
  }

  render() {
    return (
      <div>
        <style>{tableStyles}</style>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingLeft: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '1.4rem', color: Colors.textDark, fontWeight: 500, textTransform: 'uppercase' }}>
            Gerenciar Planos
          </h2>
          <Button
            color="primary"
            style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
            onClick={() => { window.location.href= urlBase.client +'panel/planregistration' }}
          >
            Novo Plano
          </Button>        
        </div>

        {/* Painel de Filtros */}
        {Array.isArray(this.state.data) && (
          <div style={this.styles.filterContainer}>
            <div style={this.styles.filterGroup}>
              <span style={this.styles.filterLabel}>Status:</span>
              <label style={this.styles.checkboxLabel}>
                <input type="checkbox" name="filterAtivo" checked={this.state.filterAtivo} onChange={this.handleFilterChange.bind(this)} />
                Ativos
              </label>
              <label style={this.styles.checkboxLabel}>
                <input type="checkbox" name="filterInativo" checked={this.state.filterInativo} onChange={this.handleFilterChange.bind(this)} />
                Inativos
              </label>
            </div>

            <div style={this.styles.divider} />

            <div style={this.styles.filterGroup}>
              <span style={this.styles.filterLabel}>Publicação:</span>
              <label style={this.styles.checkboxLabel}>
                <input type="checkbox" name="filterPublicado" checked={this.state.filterPublicado} onChange={this.handleFilterChange.bind(this)} />
                Publicados
              </label>
              <label style={this.styles.checkboxLabel}>
                <input type="checkbox" name="filterNaoPublicado" checked={this.state.filterNaoPublicado} onChange={this.handleFilterChange.bind(this)} />
                Não Publicados
              </label>
            </div>
          </div>
        )}

        {
          this.state.data == 'loading' ? (
            <div style={{textAlign: 'center'}}>
              <CircularProgress />
              <p>Carregando...</p>
            </div>
          ) : (
            this.state.data == 'error' ? (
              <p style={this.styles.error}>Erro ao buscar dados: {this.error}</p>
            ) : (
              this.state.data == 'zero' ? (
                <div style={this.styles.zero}><p>Nenhum plano cadastrado.</p></div>
              ) : (
                <div>
                  <Paper style={{overflow: 'auto', marginLeft: 10, borderRadius:10 }}>
                    <table id="table_id" className="table-striped dataTable" style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th style={{ textAlign: 'left' }}>Nome</th>
                          <th style={{ textAlign: 'left' }}>Nome Fantasia</th>
                          <th>Valor 1</th>
                          <th>Valor 2</th>      
                          <th>Valor 3</th> 
                          <th>Tipo</th>
                          <th>Serv. Público</th>
                          <th>Cartão</th>
                          <th>Boleto</th>
                          <th>Planilha</th>   
                          <th>Publicado</th>                  
                          <th>Status</th>
                          <th>Ação</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* IMPORTANTE: O React renderiza TODOS os registros da API. Quem filtra linhas é o DataTables nativo. */}
                        {this.state.data.map((item, index) => {
                          const familyTable = item.familyTable || {};
                          const serverTable = item.serverTable || {};
                          const ticketTable = item.ticketTable || {};

                          const isPlanPublicado = item.publish === true || item.publish === 'true' || item.publish === 1 || item.publish === '1';

                          return (
                            <tr key={index} className="row_table">
                              <td data-label="Cód. S4">{item.codeS4}</td>
                              <td data-label="Nome">{item.name}</td>
                              <td data-label="Nome Fantasia">{item.tradeName}</td>
                              {item.server ? 
                              [
                                <td key="v1" data-label="Fam. V1">{serverTable.value2 ? 'R$ ' + serverTable.value2 : ''}</td>,
                                <td key="v2" data-label="Fam. V2">{serverTable.value3 ? 'R$ ' + serverTable.value3 : ''}</td>,
                                <td key="v3" data-label="Fam. V3">{serverTable.value4 ? 'R$ ' + serverTable.value4 : ''}</td>
                              ] : item.card ? [
                                <td key="v1" data-label="Fam. V1">{familyTable.value2 ? 'R$ ' + familyTable.value2 : ''}</td>,
                                <td key="v2" data-label="Fam. V2">{familyTable.value3 ? 'R$ ' + familyTable.value3 : ''}</td>,
                                <td key="v3" data-label="Fam. V3">{familyTable.value4 ? 'R$ ' + familyTable.value4 : ''}</td>
                            ] : item.ticket ? [
                                <td key="v1" data-label="Fam. V1">{ticketTable.value2 ? 'R$ ' + ticketTable.value2 : ''}</td>,
                                <td key="v2" data-label="Fam. V2">{ticketTable.value3 ? 'R$ ' + ticketTable.value3 : ''}</td>,
                                <td key="v3" data-label="Fam. V3">{ticketTable.value4 ? 'R$ ' + ticketTable.value4 : ''}</td>
                            ] : [
                                <td key="v1" data-label="Fam. V1">R$ 0,00</td>,
                                <td key="v2" data-label="Fam. V2">R$ 0,00</td>,
                                <td key="v3" data-label="Fam. V3">R$ 0,00</td>
                            ]                            
                            }
              
                              <td data-label="Tipo">{item.type}</td>
                              
                              <td data-label="Serv. Público">
                                <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold',  color: item.server === true ? Colors.statusAtivoText : Colors.statusInativoText }}>                      
                                  {item.server ? <FiCheckSquare size={10} title="Disponível" /> : <FiXSquare size={10} title="Não disponível" />}
                                </span> 
                              </td>

                              <td data-label="Cartão">
                                <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold', color: item.card === true ? Colors.statusAtivoText : Colors.statusInativoText }}>                      
                                  {item.card ? <FiCheckSquare size={10} title="Disponível" /> : <FiXSquare size={10} title="Não disponível" />}
                                </span> 
                              </td>  

                              <td data-label="Boleto">
                                <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold',  color: item.ticket === true ? Colors.statusAtivoText : Colors.statusInativoText }}>                      
                                  {item.ticket ? <FiCheckSquare size={10} title="Disponível" /> : <FiXSquare size={10} title="Não disponível" />}
                                </span> 
                              </td>

                              <td data-label="Planilha">
                                {item.type === 'PJ' ? (item.usersTable ? <p>SIM</p> : <p>NÃO</p>) : ''} 
                              </td>

                              {/* Coluna 11 - Importante para a busca do DataTables */}
                              <td data-label="Publicado">
                                <span style={{display: 'none'}}>{isPlanPublicado ? 'PUBLICADO_SIM' : 'RASCUNHO_NAO'}</span>
                                <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 'bold',  color: isPlanPublicado ? Colors.statusAtivoText : Colors.statusInativoText }}>                      
                                  {isPlanPublicado ? <FiCheckSquare size={10} title="Publicado"/> : <FiXSquare size={10} title="Não Publicado" />}
                                </span>  
                              </td>

                              {/* Coluna 12 - Importante para a busca do DataTables */}
                                <td data-label="Status">
                                  {/* Esta tag oculta garante que o DataTables ache a string correta independentemente de nulos */}
                                  <span style={{ display: 'none' }}>
                                    {item.status === 'ATIVO' ? 'STATUS_ATIVO' : 'STATUS_INATIVO'}
                                  </span>
                                  
                                  <span style={{ 
                                    padding: '4px 8px', 
                                    borderRadius: '12px', 
                                    fontSize: '10px', 
                                    fontWeight: 'bold', 
                                    backgroundColor: item.status === 'ATIVO' ? Colors.statusAtivoBg : Colors.statusCanceladoBg, 
                                    color: item.status === 'ATIVO' ? Colors.statusAtivoText : Colors.statusInativoText 
                                  }}>
                                    {item.status || 'INATIVO'}
                                  </span>
                                </td>

                              <td data-label="Alterar" onClick={this.edit.bind(this, item.id || item._id)} style={{ cursor: 'pointer', padding: 0 }}>
                                <i className="fas fa-edit">&nbsp;</i>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Paper>
                </div>
              )
            )
          )
        }
      </div>
    );
  }
}

export default PlanList;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/Plans/PlanList.js
 **/